import Route from 'mewe/routes/route';

export default class SetNewPasswordRoute extends Route {
  model(params) {
    return {
      resetToken: params.id,
    };
  }
}
